type GiantNameTextProps = {
  /** Figma `giant_name_text` (118:6894). */
  text?: string;
};

const DEFAULT_TEXT = 'Обсерватория Роза';

/**
 * Figma `giant_name_text` (118:6894) + `Rectangle 379` (121:15843) behind it.
 * Text: Matias 46.641, white fill, stroke #4D3C82.
 * Plaque: #FFE493 @ 80%.
 */
export function GiantNameText({ text = DEFAULT_TEXT }: GiantNameTextProps) {
  return (
    <div className="new-delivery-texts__giant-name-group">
      <div className="new-delivery-texts__giant-name-plaque" aria-hidden />
      <svg
        className="new-delivery-texts__giant-name"
        width={408}
        height={52}
        viewBox="0 0 408 52"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <text
          className="new-delivery-texts__giant-name-text"
          textAnchor="middle"
          xmlSpace="preserve"
        >
          <tspan x={204} y={42}>
            {text}
          </tspan>
        </text>
      </svg>
    </div>
  );
}
